    <div class="container" style="margin-top: 15px;">
         <div class="row">
              <div class="col-lg-12 header">
                <span>
                   <h1 class="text-dark">
                     <img src="./assets/img/logo.jpg" alt="Jane" width=100 />
                     2020 ELECTION
                    <small>Mizoram CSC-VLE Association</small>
                  </h1>
                </span>
              </div>
         </div>
    </div>
	<div class="container" style="margin-top: 15px;">
		<div class="row">
		  <div class="col-sm-12">
			<div class="card bg-light">
			  <div class="card-body leftbo">
			    <h5 class="card-title rbo">Election Vote Status</h5>
			    <table class="table">
			    	<tbody>
			    		<tr>
			    			<td colspan="3">
			    				<canvas baseChart 
			    				[datasets]="barChartData" [labels]="barChartLabels"
			    				[options]="barChartOptions"
			    				[legend]="barChartLegend"
			    				[chartType]="barChartType"
			    				>	
			    				</canvas>
			    			</td>
			    		</tr>
			    		<tr>
			    			<th>
			    				Name of Nominee
			    			</th>
			    			<th>
			    				CSC Location
			    			</th>
			    			<th>
			    				Votes
			    			</th>
			    		</tr>
			    		<tr>
			    			<td>
						    	<span style="display: block;">Vanlalliana</span>
						    </td>
						    <td>
						    	<span style="display: block;">Sairang</span>	
			    			</td>
			    			<td>
			    				{{one}}
			    			</td>
			    		</tr>

			    		<tr>
			    			<td>
						    	<span style="display: block;">Jerome K Lalrosanga</span>
						    </td>
						    <td>	
						    	<span style="display: block;">College Veng</span>	
			    			</td>
			    			<td>
			    				{{two}}
			    			</td>
			    		</tr>

			    		<tr>
			    			<td>
						    	<span style="display: block;">R Rodinmawia</span>
						    </td>
						    <td>						    	
						    	<span style="display: block;">Khatla South</span>	
			    			</td>
			    			<td>
			    				{{three}}
			    			</td>
			    		</tr>
			    		<tr>
			    			<td>
						    	<span style="display: block;">Lalrengliana</span>
						    </td>
						    <td>
						    	<span style="display: block;">Bethlehem Vengthlang</span>	
			    			</td>
			    			<td>
			    				{{four}}
			    			</td>
			    		</tr>
			    		<tr>
			    			<td>
						    	<span style="display: block;">Richard B Lalhriatpuia</span>
						    </td>
						    <td>
						    	<span style="display: block;">Armed Veng South</span>	
			    			</td>
			    			<td>
			    				{{five}}
			    			</td>
			    		</tr>			    					    		
			    		<tr>
			    			<td>
						    	<span style="display: block;">J Lalrimawia</span>
						    </td>
						    <td>
						    	<span style="display: block;">Dawpui</span>	
			    			</td>
			    			<td>
			    				{{six}}
			    			</td>
			    		</tr>	

			    		<tr>
			    			<td>
						    	<span style="display: block;">Benjamin Lalremruata</span>
						    </td>
						    <td>
						    	<span style="display: block;">Chaltlang Dawrkawn</span>	
			    			</td>
			    			<td>
			    				{{seven}}
			    			</td>
			    		</tr>	

			    		<tr>
			    			<td>
						    	<span style="display: block;">R Lalnunsanga (Nuntea)</span>
						    </td>
						    <td>
						    	<span style="display: block;">Chhinga Veng</span>	
			    			</td>
			    			<td>
			    				{{eight}}
			    			</td>
			    		</tr>	

			    		<tr>
			    			<td>
						    	<span style="display: block;">Lalthansanga Fanai</span>
						    </td>
						    <td>
						    	<span style="display: block;">Kanan Veng</span>	
			    			</td>
			    			<td>
			    				{{nine}}
			    			</td>
			    		</tr>	
			    		<tr>
			    			<td>
						    	<span style="display: block;">R Lalrinmawia</span>
						    </td>
						    <td>
						    	<span style="display: block;">Durtlang</span>	
			    			</td>
			    			<td>
			    				{{ten}}
			    			</td>
			    		</tr>	

			    		<tr>
			    			<td>
						    	<span style="display: block;">Lalramthara Pautu</span>
						    </td>
						    <td>
						    	<span style="display: block;">Saron Veng</span>	
			    			</td>
			    			<td>
			    				{{eleven}}
			    			</td>
			    		</tr>	

			    		<tr>
			    			<td>
						    	<span style="display: block;">Anthony Vanlalhruaia</span>
						    </td>
						    <td>
						    	<span style="display: block;">Bethlehem Veng</span>	
			    			</td>
			    			<td>
			    				{{twelve}}
			    			</td>
			    		</tr>	

			    		<tr>
			    			<td>
						    	<span style="display: block;">Zairemtluanga Ralte</span>
						    </td>
						    <td>
						    	<span style="display: block;">Durtlang North</span>	
			    			</td>
			    			<td>
			    				{{thirteen}}
			    			</td>
			    		</tr>	
			    		<tr>
			    			<td>
						    	<span style="display: block;">Lalremruata</span>
						    </td>
						    <td>
						    	<span style="display: block;">Salem Veng</span>	
			    			</td>
			    			<td>
			    				{{fourteen}}
			    			</td>
			    		</tr>	

			    	</tbody>
			    </table>
			  </div>
			</div>
		  </div>
		</div>
	</div>
